import { defineComponent as _defineComponent } from 'vue'
import Icon from './Icon.vue';
import TransitionFade from './transitions/TransitionFade.vue';
import vTrapFocus from '../directives/trap-focus';
import { computed, nextTick, ref, watch } from 'vue';
import { getFocusableElements } from '../utilities/dom';
import { usePreventBodyScroll } from 'JS/composables/prevent-body-scroll';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  props: {
    isOpen: { type: Boolean },
    menuTitle: null,
    side: { default: 'right' },
    keepAlive: { type: Boolean },
    triggerScrollToTop: null,
    size: { default: 'md' }
  },
  emits: ["close", "shown", "hidden"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void,
	(e: 'shown'): void,
	(e: 'hidden'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen?: boolean, menuTitle: string, side: 'left' | 'right', keepAlive?: boolean, triggerScrollToTop?: string, size: 'sm' | 'md' }





function close() {
	emit('close');
}

const el = ref<HTMLElement | null>(null);
const sidemenu = ref<HTMLElement | null>(null);

function scrollToTop(): void {
	if (sidemenu.value) {
		nextTick(() => {
			sidemenu.value.scrollTop = 0;
		});
	}
}

function handleKeyDown(e: KeyboardEvent) {
	if (!props.isOpen) return;

	if (e.key === 'Escape') {
		e.preventDefault();
		close();
	}
}

usePreventBodyScroll(computed(() => props.isOpen));

const isVisiblyOpen = ref(props.isOpen);
const shouldRenderSlotContent = computed(() => props.keepAlive || isVisiblyOpen.value);
function handleAfterLeave() {
	emit('hidden');
	isVisiblyOpen.value = false;
}

let previouslyFocusedElement: HTMLElement | null = null;
watch(() => props.isOpen, isOpen => {
	if (isOpen) {
		isVisiblyOpen.value = true;
		previouslyFocusedElement = document.activeElement as HTMLElement;
		nextTick(function() {
			const firstFocusable = getFocusableElements(el.value as HTMLElement)[0];
			firstFocusable?.focus();
		});
		scrollToTop();
	} else {
		if (previouslyFocusedElement) {
			nextTick(() => {
				previouslyFocusedElement?.focus();
				previouslyFocusedElement = null;
			});
		}
	}
});

watch(() => props.triggerScrollToTop, val => {
	scrollToTop();
});

return { __sfc: true,props, emit, close, el, sidemenu, scrollToTop, handleKeyDown, isVisiblyOpen, shouldRenderSlotContent, handleAfterLeave, previouslyFocusedElement, Icon, TransitionFade, vTrapFocus }
}

})